import { PackageInfoArrayGenericResponse } from "@be/api";
import { api } from "@/backend";
import { useAsyncState } from "@vueuse/core";
import { computed, ref } from "vue";
import { contextAccount } from "@/state/account";

// This will keep menu in sync with the user's account
const { state, isReady, isLoading, execute } = useAsyncState(
  async () => {
    const response = await api.getContentMenu(undefined, {
      accountId: contextAccount.value?.accountId,
    });
    return response.data;
  },
  { data: [] } as PackageInfoArrayGenericResponse,
  { immediate: false },
);

export { isReady, isLoading, execute };

// This keeps track of user filter selections
export const filter = ref<string[]>([]);

export const packages = computed(() => state.value.data ?? []);

export const toggleFilter = (category: string) => {
  if (filter.value.includes(category)) {
    filter.value = filter.value.filter((c) => c !== category);
  } else {
    filter.value.push(category);
  }
};

export const getPackage = (packageId: number | string) => {
  let id = typeof packageId === "string" ? parseInt(packageId, 10) : packageId;

  return packages.value.find((p) => p.packageId === id);
};

export const getPackageAsync = async (packageId: number | string) => {
  let id = typeof packageId === "string" ? parseInt(packageId, 10) : packageId;
  if (
    packages.value.length === 0 ||
    !packages.value.some((p) => p.packageId === id)
  )
    await execute();

  return getPackage(id);
};
